// Module
var code = `<div class="code-sample-item-container {{codeSampleIdClean}} {{classVal}}">
  <div class="code-sample-title">{{title}}</div>
  <div class="code-sample-subtitle">{{subtitle}}</div>

  <pre
    class="code-sample-content-container bash-theme code-sample-content-{{codeSampleIdClean}}"
  >
        <code class="hljs language-javascript">

        </code>
    </pre>

  <div class="code-sample-footer">{{footer}}</div>
</div>
`;
// Exports
module.exports = code;